<div class="access-denied-container">
  <div class="access-denied-content">
    <div class="lock-icon">
      <svg
        width="80"
        height="80"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z"
          fill="#666666"
        />
      </svg>
    </div>

    <h1 class="access-denied-title">Access Denied</h1>

    <p class="access-denied-message">
      You do not have the necessary permissions to view this page.
    </p>

    <p class="access-denied-contact">Please contact an <strong>administrator</strong>.</p>

    <div class="az-logo">
      <img src="assets/images/az-logo.svg" alt="AstraZeneca" />
      <span class="az-text">AstraZeneca</span>
    </div>
  </div>
</div>
